<!-- 首部设备：控制柜；category：kzgs。data 为单台设备原始 JSON 的 UTF-8 Base64，取自路由查询参数。 -->
<template>
  <main class="device-development">设备详情页正在开发中</main>
</template>

<script>
export default {
  name: 'HeadControlCabinet'
}
</script>

<style scoped>
.device-development {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 16px 16px calc(16px + env(safe-area-inset-bottom));
  background: #F2F7FC;
  color: #8096AD;
  font-size: 16px;
}
</style>
